import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, LayoutDashboard, User, Info, Search, Star } from "lucide-react";
import axios from "axios";
import { API, useAuth } from "@/App";

const BottomNav = ({ userType }) => {
  const location = useLocation();
  const { getAuthHeaders } = useAuth();
  const basePath = `/${userType}`;
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    fetchUnreadCount();
    // Poll for new messages every 30 seconds
    const interval = setInterval(fetchUnreadCount, 30000);
    
    // Listen for message read events to refresh badge immediately
    const handleMessagesRead = () => {
      fetchUnreadCount();
    };
    window.addEventListener('messagesRead', handleMessagesRead);
    
    return () => {
      clearInterval(interval);
      window.removeEventListener('messagesRead', handleMessagesRead);
    };
  }, []);

  const fetchUnreadCount = async () => {
    try {
      const response = await axios.get(`${API}/unread-count`, { 
        
        headers: getAuthHeaders()
      });
      setUnreadCount(response.data.unread_count || 0);
    } catch (error) {
      // Silently fail - user might not be logged in
    }
  };

  const influencerNav = [
    { path: `${basePath}/home`, icon: Home, label: "Home", showBadge: false },
    { path: `${basePath}/dashboard`, icon: LayoutDashboard, label: "Dashboard", showBadge: true },
    { path: `${basePath}/profile`, icon: Star, label: "Star Profile", showBadge: false },
    { path: `${basePath}/about`, icon: Info, label: "About", showBadge: false },
  ];

  const brandNav = [
    { path: `${basePath}/home`, icon: Home, label: "Home", showBadge: false },
    { path: `${basePath}/hub`, icon: LayoutDashboard, label: "Hub", showBadge: true },
    { path: `${basePath}/profile`, icon: User, label: "Profile", showBadge: false },
    { path: `${basePath}/about`, icon: Info, label: "About", showBadge: false },
  ];

  const navItems = userType === "influencer" ? influencerNav : brandNav;

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-[#E2E8F0] z-50 bottom-nav safe-area-bottom" data-testid="bottom-nav">
      <div className="max-w-lg mx-auto">
        <div className="flex justify-around items-center py-2">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            const Icon = item.icon;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`relative flex flex-col items-center py-2 px-3 rounded-lg transition-colors ${
                  isActive 
                    ? "text-[#FF69B4]" 
                    : "text-[#64748B] hover:text-[#1E293B]"
                }`}
                data-testid={`nav-${item.label.toLowerCase()}`}
              >
                <div className="relative">
                  <Icon className={`w-5 h-5 ${isActive ? "text-[#FF69B4]" : ""}`} />
                  {/* Unread Badge */}
                  {item.showBadge && unreadCount > 0 && (
                    <span 
                      className="absolute -top-2 -right-2 min-w-[18px] h-[18px] bg-[#FF69B4] text-white text-[10px] font-bold rounded-full flex items-center justify-center px-1"
                      data-testid="unread-badge"
                    >
                      {unreadCount > 99 ? '99+' : unreadCount}
                    </span>
                  )}
                </div>
                <span className="text-xs mt-1 font-medium">{item.label}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default BottomNav;
